// Sidebar entries owned by the Tools module. The shell places them: see
// src/app/nav.tsx and src/modules/README.md.
import { SidebarType } from '@/types/shared'
import { toolsPaths } from './paths'
import { DEPARTMENT_IDS } from '@/constants/departments'

export const toolsNav = {
    // DataCentral access only; the external API enforces its own policy.
    wafFreeReport: {
        title: 'tools-waf-free-report',
        path: toolsPaths.toolsWafFreeReport,
        allowed_department_ids: [
            DEPARTMENT_IDS.MARKETING,
            DEPARTMENT_IDS.MARKETING_MKT,
        ],
    },
    convertWebp: {
        title: 'tools-convert-webp',
        path: toolsPaths.toolsConvertWebp,
        ignorePermission: true,
    },
} satisfies Record<string, SidebarType>
